
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lower-image-size",
      function () {
        return require("private-next-pages/lower-image-size/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lower-image-size"])
      });
    }
  